'use client'
import { useRouter } from 'next/navigation'

import LoginPage from '@/app/auth/login/login'
import useAuthStore from '@/app/auth/login/store'
import { Dialog, DialogContent } from '@/components/ui/dialog'

function Login() {
  const router = useRouter()
  const setState = useAuthStore((state) => state.setState)

  return (
    <Dialog
      open={true}
      onOpenChange={() => {
        router.back()
        setState('login')
      }}
    >
      <DialogContent
        className={`
          flex min-h-[500px] w-full max-w-[90%] flex-col items-center
          justify-center bg-white p-6

          lg:max-w-5xl lg:p-10

          md:max-w-3xl md:p-8

          sm:max-w-xl

          xl:max-w-6xl
        `}
      >
        <LoginPage />
      </DialogContent>
    </Dialog>
  )
}

export default Login
